import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BrandConfigurationReportTab from './brandConfigurationTab';
import Sorting from '../../components/company_panel/common/sorting';
import { capitalizeAllFirstLetters, capitalizeFirstLetter, formateDate, formateDateWithMonth, formateDateWithTime, formatToTwoDecimals, getBrandId, getCompany, showPrice, getExcelColumnWidths } from '../../helpers/commonFunctions';
import CustomPagination from '../../components/company_panel/common/custompagination';
import Loader from '../../components/company_panel/common/loader';
import notFound from '../../../src/assets/company/img/no-record-found.png'
import CustomRangepicker from '../../components/company_panel/common/rangepicker';
import StatusFilter from '../../components/company_panel/common/statusFilter';
import { LOADER_TIME, showFilterlist, SOCKET_EVENTS } from '../../utils/Constants';
import { SOCKET_CLIENT } from '../../utils/socket';
import { ListBrandItemCostCalculationReport, ExportBrandItemCostCalculationReport } from '../../services/company_panel/brandReport.services';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { GetBrandOutletsList } from '../../services/company_panel/outletService';
import { GetBrandsHavingOutlets } from '../../services/company_panel/brandService';
import { TagPicker } from 'rsuite';
import $ from 'jquery';
import Swal from 'sweetalert2';
import GlobalLoader from '../../components/company_panel/common/globalLoader';


const BrandItemCostList = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/company/dashboard" }, { title: "Pages", url: "" },]
    const [list, setList] = useState([])
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(10)
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true)
    const [globalLoader, setGlobalLoader] = useState(false);
    const [search, setSearch] = useState({})
    const [globalSearch, setGlobalSearch] = useState("")
    const [resetdate, setResetDate] = useState(false);
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [isOutletChanged, setIsOutletChanged] = useState(false);

    const [dateFilterValue, setDateFilterValue] = useState([]);
    const [businessDateFilterValue, setBusinessDateFilterValue] = useState([]);

    const [brandList, setBrandList] = useState([]);
    const [outletList, setOutletList] = useState([]);
    const [selectedBrandIds, setSelectedBrandIds] = useState([]);
    const [selectedOutletIds, setSelectedOutletIds] = useState([]);

    // server-side export progress (driven by socket EXPORT_PROGRESS). Completed/failed are
    // handled globally in companyLayout (download / toast); here we only render the live bar.
    const [exportProgress, setExportProgress] = useState(null);
    const [exporting, setExporting] = useState(false);
    const exportJobIdRef = useRef(null);

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
            setIsOutletChanged(!isOutletChanged);
        })
    });

    useEffect(() => {
        const handleExportProgress = (response) => {
            const data = response?.data;
            if (!data || !data.jobId) return;
            if (response?.event !== SOCKET_EVENTS.REPORTS.ITEM_COST_CALCULATION.EXPORT_PROGRESS) return;
            if (exportJobIdRef.current && data.jobId !== exportJobIdRef.current) return;

            const percent = Number(data.percent) || 0;
            setExportProgress({
                status: percent >= 100 ? 'completed' : 'progress',
                percent,
                processed: data.processed,
                total: data.total,
            });

            if (percent >= 100) {
                setExporting(false);
                exportJobIdRef.current = null;
                setTimeout(() => setExportProgress(null), 3000);
            }
        };

        SOCKET_CLIENT.on('GET-DATA', handleExportProgress);
        return () => {
            SOCKET_CLIENT.off('GET-DATA', handleExportProgress);
        };
    }, []);

    useEffect(() => {
        if (search) {
            setLoader(true)
            const formData = new FormData()
            formData.append("page", page)
            formData.append("per_page", itemPerPage)
            formData.append("sort", JSON.stringify(sorting))
            formData.append("search", JSON.stringify(search))
            formData.append("global_search", globalSearch)
            formData.append('company_id', getCompany().company_id);
            ListBrandItemCostCalculationReport(formData).then(data => {
                setDataLength(data?.data?.response?.count || 0);
                setList(data?.data?.response?.rows || [])
                setTimeout(() => {
                    setLoader(false)
                }, LOADER_TIME);
            }).catch(error => {
                setList([]);
                setDataLength(0);
                setTimeout(() => {
                    setLoader(false)
                }, LOADER_TIME);
                Swal.fire({
                    customClass: 'swal-wide',
                    position: 'top-right',
                    icon: 'error',
                    title: error?.response?.data?.errors?.message || error?.message,
                    showConfirmButton: false,
                    timer: 1000,
                    toast: true,
                })
                console.log("error ====> ", error);
            })
        }

    }, [sorting, search, globalSearch, page, isBrandChanged, isOutletChanged])

    useEffect(() => {
        GetBrandsHavingOutlets(getCompany().company_id).then(data => {
            setBrandList(data && data.data && data.data.response ? data.data.response : []);
        }).catch(error => {
            console.log("error=====>", error)
        })
    }, [])

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (Array.isArray(value)) {
            if (value.length > 0) {
                sr[key] = value;
            } else {
                delete sr[key];
            }
        } else if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }

        if (key == 'business_date') {
            setDateFilterValue([]);
            delete sr['created'];
        } else if (key == 'created') {
            setBusinessDateFilterValue([])
            delete sr['business_date'];
        }
        setSearch(sr);
    }

    const handleBrandChange = (selectedBrands) => {
        const brands = selectedBrands || [];
        setSelectedBrandIds(brands);

        if (brands.length === 0) {
            setOutletList([]);
            setSelectedOutletIds([]);
            const sr = { ...search };
            delete sr.brand_ids;
            delete sr.outlet_ids;
            setSearch(sr);
            return;
        }

        GetBrandOutletsList({ brand_ids: JSON.stringify(brands) }).then(data => {
            const outlets = data && data.data && data.data.response ? data.data.response : [];
            setOutletList(outlets);
            const validOutletIds = outlets.map(o => o.id);
            const filteredSelectedOutlets = selectedOutletIds.filter(id => validOutletIds.includes(id));
            setSelectedOutletIds(filteredSelectedOutlets);

            const sr = { ...search };
            sr.brand_ids = brands;
            if (filteredSelectedOutlets.length > 0) {
                sr.outlet_ids = filteredSelectedOutlets;
            } else {
                delete sr.outlet_ids;
            }
            setSearch(sr);
        }).catch(error => {
            console.log("error=====>", error)
        });
    }

    const handleOutletChange = (selectedOutlets) => {
        const outlets = selectedOutlets || [];
        setSelectedOutletIds(outlets);
        prepareSearch('outlet_ids', outlets);
    }

    const removeBrand = (brandId) => {
        handleBrandChange(selectedBrandIds.filter(id => id !== brandId));
    }

    const removeOutlet = (outletId) => {
        handleOutletChange(selectedOutletIds.filter(id => id !== outletId));
    }

    const brandData = brandList?.map(item => ({
        label: capitalizeAllFirstLetters(item?.name),
        value: item?.id
    })) || [];

    const filteredOutletData = outletList?.map(item => ({
        label: `${capitalizeAllFirstLetters(item?.outlet_name)}${item?.short_code ? ` (${item.short_code})` : ''}`,
        value: item?.id
    })) || [];

    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSelectedBrandIds([]);
        setSelectedOutletIds([]);
        setSearch({})
        setResetDate(!resetdate)
    }

    const headerMapping = {
        "business_date": "Business Date",
        "brand": "Brand",
        "area": "Area",
        "store_short_code": "Store Short Code",
        "outlet_name": "Outlet",
        "segment": "Segment",
        "aggregator": "Aggregator",
        "item_category": "Category",
        "order_id": "Order ID",
        "item_id": "Item ID",
        "item_name": "Item Name",
        "item_type": "Item Type",
        "item_quantity": "Quantity Sold",
        "item_selling_price": "Selling Price",
        "item_cost_price": "Cost Price",
        "cost_percent": "Cost(%)",
        "item_total_revenue": "Total sales",
        "tax_percent": "Tax(%)",
        "net_sales": "Net Sales",
        "item_total_cost": "Total cost",
        "item_total_profit": "Profit",
        "item_total_profit_margin": "Profit Margin(%)",
    };

    const handleExport = () => {
        setExporting(true);
        setExportProgress({ status: 'progress', percent: 0 });
        const formData = new FormData()
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('company_id', getCompany().company_id);
        ExportBrandItemCostCalculationReport(formData).then(data => {
            const body = data?.data?.response || data?.data || {};
            const jobId = body.jobId || body.job_id || data?.data?.jobId;
            const message = data?.data?.message || body.message || 'Export started';
            if (jobId) {
                exportJobIdRef.current = jobId;
            }
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'success',
                title: message,
                showConfirmButton: false,
                timer: 3000,
                toast: true,
                position: 'top-right',
            });
        }).catch(error => {
            console.log("error ====> ", error);
            Swal.fire({
                customClass: 'swal-wide',
                icon: 'error',
                title: error?.response?.data?.errors?.message || error?.message || 'Export failed',
                showConfirmButton: false,
                timer: 3000,
                toast: true,
                position: 'top-right',
            });
            setExporting(false);
            setExportProgress(null);
            exportJobIdRef.current = null;
        });
    };

    const handleExportOld = () => {
        setGlobalLoader(true);
        const formData = new FormData()
        formData.append("page", 1)
        formData.append("per_page", dataLength)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('company_id', getCompany().company_id);
        ExportBrandItemCostCalculationReport(formData).then(data => {
            setDataLength(data?.data?.response?.count || 0);
            const listData = data?.data?.response?.rows || [];
            const printData = listData.map((item) => {
                const transformedItem = {};
                const businessDate = item?.business_date ? formateDate(item?.business_date) : 'N/A';
                const brand = item?.brand_name || "N/A";
                const area = item?.area_name || "N/A";
                const storeShortCode = item?.outlet_short_code || "N/A";
                const OutletName = item?.outlet_name || 'N/A'
                const segment = item?.order_mode_name || 'N/A'
                const aggregator = item?.aggregator_name || 'N/A'
                const itemCategory = item?.category_name || 'N/A';
                const itemID = item?.entity_id || 'N/A';
                const itemName = item?.item_name || 'N/A';
                const orderID = item?.order_id || 'N/A';
                const itemType = item?.item_type ? capitalizeAllFirstLetters(item.item_type.replace(/_/g, ' ')) : 'N/A';
                const itemQuantitySold = item?.item_quantity || 'N/A';
                const sellingPrice = item?.selling_price || 0;
                const costPrice = item?.item_cost || 0;
                const costPercent = item?.cost_percentage || 'N/A';
                const itemTotalRevenue = item?.net_sales || 0;
                const taxPercent = 15;
                const netSales = item?.net_sales_without_tax || 0;
                const totalCost = item?.item_total_cost || 0;
                const totalProfit = item?.item_total_profit || 0;
                const totalProfitMargin = item?.item_total_profit_margin || 0;

                for (const key in headerMapping) {
                    if (headerMapping.hasOwnProperty(key)) {
                        const newKey = headerMapping[key];
                        switch (key) {
                            case "business_date":
                                transformedItem[newKey] = businessDate;
                                break;
                            case "brand":
                                transformedItem[newKey] = capitalizeFirstLetter(brand);
                                break;
                            case "area":
                                transformedItem[newKey] = capitalizeFirstLetter(area);
                                break;
                            case "store_short_code":
                                transformedItem[newKey] = storeShortCode
                                break;
                            case "outlet_name":
                                transformedItem[newKey] = capitalizeFirstLetter(OutletName)
                                break;
                            case "segment":
                                transformedItem[newKey] = capitalizeFirstLetter(segment)
                                break;
                            case "aggregator":
                                transformedItem[newKey] = capitalizeFirstLetter(aggregator)
                                break;
                            case "item_category":
                                transformedItem[newKey] = capitalizeFirstLetter(itemCategory)
                                break;
                            case "item_id":
                                transformedItem[newKey] = '#' + (itemID);
                                break;
                            case "order_id":
                                transformedItem[newKey] = orderID;
                                break;
                            case "item_type":
                                transformedItem[newKey] = itemType;
                                break;
                            case "item_name":
                                transformedItem[newKey] = capitalizeFirstLetter(itemName);
                                break;
                            case "item_quantity":
                                transformedItem[newKey] = capitalizeFirstLetter(itemQuantitySold);
                                break;
                            case "item_selling_price":
                                transformedItem[newKey] = `${showPrice(sellingPrice)} SAR`;
                                break;
                            case "item_cost_price":
                                transformedItem[newKey] = `${showPrice(costPrice)} SAR`;
                                break;
                            case "cost_percent":
                                transformedItem[newKey] = `${showPrice(costPercent)}`;
                                break;
                            case "item_total_revenue":
                                transformedItem[newKey] = `${showPrice(itemTotalRevenue)} SAR`;
                                break;
                            case "tax_percent":
                                transformedItem[newKey] = `${taxPercent} %`;
                                break;
                            case "net_sales":
                                transformedItem[newKey] = `${showPrice(netSales)} SAR`;
                                break;
                            case "item_total_cost":
                                transformedItem[newKey] = `${showPrice(totalCost)} SAR`;
                                break;
                            case "item_total_profit":
                                transformedItem[newKey] = `${showPrice(totalProfit)} SAR`;
                                break;
                            case "item_total_profit_margin":
                                transformedItem[newKey] = `${formatToTwoDecimals(totalProfitMargin)} %`;
                                break;
                            default:
                                console.warn(`Unexpected key in headerMapping: ${key}`);
                                transformedItem[newKey] = 'N/A';
                                break;
                        }
                    }
                }
                return transformedItem;
            });

            const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
            ws['!cols'] = getExcelColumnWidths(printData, Object.values(headerMapping));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, 'Brand-Item-Cost-Report.xlsx');
            setGlobalLoader(false);
        }).catch(error => {
            console.log("error ====> ", error);
            setGlobalLoader(false);
        })
    };


    return (
        <>
            {globalLoader && <GlobalLoader />}
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Brand Report</h4>
                    </div>
                    <div className='page-header-right ms-auto'>
                        <button onClick={handleExport} disabled={dataLength === 0 || exporting} className="btn btn-primary ms-2">{exporting ? 'Exporting...' : 'Export Report'}</button>
                    </div>
                </div>
                {exportProgress && (() => {
                    const isDone = exportProgress.status === 'completed';
                    const percent = exportProgress.percent || 0;
                    const accent = isDone ? '#22c55e' : '#2f9bff';
                    return (
                        <div style={{
                            display: 'flex', alignItems: 'center', gap: '16px',
                            background: '#fff', border: '1px solid #e7ecf3', borderLeft: `4px solid ${accent}`,
                            borderRadius: '12px', padding: '14px 18px', marginBottom: '16px',
                            boxShadow: '0 2px 10px rgba(16, 30, 54, 0.06)'
                        }}>
                            <div style={{
                                width: '40px', height: '40px', flexShrink: 0, borderRadius: '50%',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                background: isDone ? 'rgba(34,197,94,0.12)' : 'rgba(47,155,255,0.12)', color: accent
                            }}>
                                {isDone ? (
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5" /></svg>
                                ) : (
                                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" style={{ animation: 'spin 0.9s linear infinite' }}><path d="M21 12a9 9 0 1 1-6.219-8.56" /></svg>
                                )}
                            </div>
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: '8px' }}>
                                    <span style={{ fontWeight: 600, color: '#1f2d3d', fontSize: '14px' }}>
                                        {isDone ? 'Export completed' : 'Exporting item cost report'}
                                        {exportProgress.total ? (
                                            <span style={{ fontWeight: 400, color: '#8a97a8', marginLeft: '8px', fontSize: '13px' }}>
                                                {(exportProgress.processed || 0).toLocaleString()} / {Number(exportProgress.total).toLocaleString()} records
                                            </span>
                                        ) : null}
                                    </span>
                                    <span style={{ fontWeight: 700, color: accent, fontSize: '14px', whiteSpace: 'nowrap' }}>{percent}%</span>
                                </div>
                                <div style={{ height: '8px', background: '#eef2f7', borderRadius: '999px', overflow: 'hidden' }}>
                                    <div style={{
                                        height: '100%', width: `${percent}%`, borderRadius: '999px',
                                        background: isDone ? accent : 'linear-gradient(90deg, #2f9bff, #6cb8ff)',
                                        transition: 'width 0.4s ease'
                                    }} />
                                </div>
                            </div>
                            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                        </div>
                    );
                })()}
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                        <div className='col-12'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <BrandConfigurationReportTab tab='cost' />
                            </div>
                        </div>
                    </div>
                    <div className="gap-20">
                        <div className='page-header d-flex align-items-center mb-0 flex-wrap'>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='page-header-right ms-auto'>
                                <div className='d-flex gap-3 align-items-center flex-wrap'>
                                    <div className="form-group mb-0 multi-filter-picker" style={{ width: '200px' }}>
                                        <TagPicker
                                            data={brandData}
                                            value={selectedBrandIds}
                                            onChange={handleBrandChange}
                                            placeholder="Select Brands"
                                            className='form-control form-control-select'
                                            cleanable={false}
                                            menuStyle={{ maxHeight: 200, overflowY: 'auto' }}
                                            renderMenu={menu => {
                                                const allChecked = brandData.length > 0 && selectedBrandIds.length === brandData.length;
                                                const toggleAll = () => {
                                                    if (allChecked) {
                                                        handleBrandChange([]);
                                                    } else {
                                                        handleBrandChange(brandData.map(b => b.value));
                                                    }
                                                };
                                                return (
                                                    <>
                                                        <div className='rs-picker-list-item cp'>
                                                            <div className={'rs-check-item rs-checkbox e_none' + (allChecked ? ' rs-checkbox-checked' : '')} onClick={toggleAll}>
                                                                <div className='rs-checkbox-checker'>
                                                                    <label htmlFor='brand-select-all'>
                                                                        <span className='rs-checkbox-control'>
                                                                            <input type='checkbox' id='brand-select-all' checked={allChecked} readOnly />
                                                                            <span className='rs-checkbox-inner'></span>
                                                                        </span>
                                                                        <span className='rs-checkbox-label'>Select All</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {menu}
                                                    </>
                                                );
                                            }}
                                            renderValue={(value, items) => {
                                                const count = items.length;
                                                if (count === 0) return null;
                                                if (count === 1) {
                                                    return <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{items[0]?.label}</span>;
                                                }
                                                return <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>{count} brands selected</span>;
                                            }}
                                        />
                                    </div>
                                    <div className="form-group mb-0 multi-filter-picker" style={{ width: '200px' }}>
                                        <TagPicker
                                            data={filteredOutletData}
                                            value={selectedOutletIds}
                                            onChange={handleOutletChange}
                                            placeholder="Select Outlets"
                                            className='form-control form-control-select'
                                            cleanable={false}
                                            menuStyle={{ maxHeight: 200, overflowY: 'auto' }}
                                            renderMenu={menu => {
                                                const allChecked = filteredOutletData.length > 0 && selectedOutletIds.length === filteredOutletData.length;
                                                const toggleAll = () => {
                                                    if (allChecked) {
                                                        handleOutletChange([]);
                                                    } else {
                                                        handleOutletChange(filteredOutletData.map(o => o.value));
                                                    }
                                                };
                                                return (
                                                    <>
                                                        <div className='rs-picker-list-item cp'>
                                                            <div className={'rs-check-item rs-checkbox e_none' + (allChecked ? ' rs-checkbox-checked' : '')} onClick={toggleAll}>
                                                                <div className='rs-checkbox-checker'>
                                                                    <label htmlFor='outlet-select-all'>
                                                                        <span className='rs-checkbox-control'>
                                                                            <input type='checkbox' id='outlet-select-all' checked={allChecked} readOnly />
                                                                            <span className='rs-checkbox-inner'></span>
                                                                        </span>
                                                                        <span className='rs-checkbox-label'>Select All</span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {menu}
                                                    </>
                                                );
                                            }}
                                            renderValue={(value, items) => {
                                                const count = items.length;
                                                if (count === 0) return null;
                                                if (count === 1) {
                                                    return <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{items[0]?.label}</span>;
                                                }
                                                return <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>{count} outlets selected</span>;
                                            }}
                                        />
                                    </div>
                                    <div className="date-input">
                                        <CustomRangepicker business_date={true} value={businessDateFilterValue} GetDateRange={(e) => { prepareSearch("business_date", e) }}
                                            resetdate={resetdate} />
                                    </div>
                                    <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                                </div>
                            </div>
                        </div>
                        {selectedBrandIds.length > 0 && (
                            <div className='d-flex flex-wrap gap-2 mt-2'>
                                <span className='text-muted me-1 align-self-center'>Brands:</span>
                                {selectedBrandIds.map(id => {
                                    const brand = brandList.find(b => b.id === id);
                                    if (!brand) return null;
                                    return (
                                        <span key={`b-${id}`} style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#2f9bff', color: '#fff', borderRadius: '14px', padding: '4px 10px', fontSize: '13px', fontWeight: 500 }}>
                                            <span>{capitalizeAllFirstLetters(brand.name)}</span>
                                            <button type='button' aria-label='Remove' onClick={() => removeBrand(id)} style={{ background: 'transparent', border: 'none', cursor: 'pointer', marginLeft: 6, padding: 0, lineHeight: 1, color: '#fff', display: 'inline-flex', alignItems: 'center' }}>
                                                <svg width='12' height='12' viewBox='0 0 16 16' fill='currentColor' aria-hidden='true'><path d='M2.784 2.089l.069.058 5.146 5.147 5.146-5.147a.5.5 0 01.765.638l-.058.069L8.705 8l5.147 5.146a.5.5 0 01-.638.765l-.069-.058-5.146-5.147-5.146 5.147a.5.5 0 01-.765-.638l.058-.069L7.293 8 2.146 2.854a.5.5 0 01.638-.765z'></path></svg>
                                            </button>
                                        </span>
                                    );
                                })}
                            </div>
                        )}
                        {selectedOutletIds.length > 0 && (
                            <div className='d-flex flex-wrap gap-2 mt-2'>
                                <span className='text-muted me-1 align-self-center'>Outlets:</span>
                                {selectedOutletIds.map(id => {
                                    const outlet = outletList.find(o => o.id === id);
                                    if (!outlet) return null;
                                    return (
                                        <span key={`o-${id}`} style={{ display: 'inline-flex', alignItems: 'center', backgroundColor: '#e7f1ff', color: '#1565c0', border: '1px solid #b6d4fe', borderRadius: '14px', padding: '4px 10px', fontSize: '13px', fontWeight: 500 }}>
                                            <span>{capitalizeAllFirstLetters(outlet.outlet_name)}{outlet.short_code ? ` (${outlet.short_code})` : ''}</span>
                                            <button type='button' aria-label='Remove' onClick={() => removeOutlet(id)} style={{ background: 'transparent', border: 'none', cursor: 'pointer', marginLeft: 6, padding: 0, lineHeight: 1, color: '#1565c0', display: 'inline-flex', alignItems: 'center' }}>
                                                <svg width='12' height='12' viewBox='0 0 16 16' fill='currentColor' aria-hidden='true'><path d='M2.784 2.089l.069.058 5.146 5.147 5.146-5.147a.5.5 0 01.765.638l-.058.069L8.705 8l5.147 5.146a.5.5 0 01-.638.765l-.069-.058-5.146-5.147-5.146 5.147a.5.5 0 01-.765-.638l.058-.069L7.293 8 2.146 2.854a.5.5 0 01.638-.765z'></path></svg>
                                            </button>
                                        </span>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="%"><span>Business Date</span></th>
                                        <th width="%"><span>Order ID</span></th>
                                        <th width="%"><span>SKU</span></th>
                                        <th width="%"><span>Brand</span></th>
                                        <th width="%"><span>Area</span></th>
                                        <th width="%"><span>Store Short Code</span></th>
                                        <th width="%"><span>Outlet</span></th>
                                        <th width="%"><span>Segment</span></th>
                                        <th width="%"><span>Aggregator</span></th>
                                        <th width="%"><span>Category</span></th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Item ID</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="id" />
                                            </div>
                                        </th>
                                        <th width="%"><span>Item Name</span></th>
                                        <th width="%"><span>Item Type</span></th>
                                        <th className='text-end' width="8%"><span>Quantity sold</span></th>
                                        <th className='text-end' width="%"><span>Selling price</span></th>
                                        <th className='text-end' width="%"><span>Cost price</span></th>
                                        <th className='text-end' width="%"><span>Cost(%)</span></th>
                                        <th className='text-end' width="%"><span>Total sales</span></th>
                                        <th className='text-end' width="%"><span>Total discount</span></th>
                                        <th className='text-end' width="%"><span>Tax(%)</span></th>
                                        <th className='text-end' width="%"><span>Net sales</span></th>
                                        <th className='text-end' width="%"><span>Total cost</span></th>
                                        <th className='text-end' width="%"><span>Profit</span></th>
                                        <th className='text-end' width="10%"><span>Profit Margin (%)</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={24}><Loader /></td>
                                        </tr> : <>
                                            {list?.length ? list.map((row, i) => (
                                                <tr key={i}>
                                                    <td>{formateDateWithMonth((row?.business_date))}</td>
                                                    <td>{row?.order_id ? `#${row?.order_id}` : "-"}</td>
                                                    <td>{row?.item_sku ? row?.item_sku : "-"}</td>
                                                    <td>{row?.brand_name}</td>
                                                    <td>{row?.area_name}</td>
                                                    <td>{row?.outlet_short_code}</td>
                                                    <td>{row?.outlet_name}</td>
                                                    <td>{row?.aggregator_name ? 'Outsource' : row?.order_mode_name}</td>
                                                    <td>{row?.aggregator_name ? row?.aggregator_name : '-'}</td>
                                                    <td>{row?.category_name ? capitalizeFirstLetter(row?.category_name) : "-"}</td>
                                                    <td>#{row?.entity_id}</td>
                                                    <td>{row?.item_name ? capitalizeFirstLetter(row?.item_name) : "-"}</td>
                                                    <td>{row?.item_type ? capitalizeAllFirstLetters(row?.item_type.replace(/_/g, ' ')) : "-"}</td>
                                                    <td className='text-end'>{row?.item_quantity ? Number(row?.item_quantity) : "-"}</td>
                                                    <td className='text-end'>{row?.selling_price ? showPrice(row?.selling_price) : "-"}</td>
                                                    <td className='text-end'>{row?.item_cost ? showPrice(row?.item_cost) : "-"}</td>
                                                    <td className='text-end'>{row?.cost_percentage ? Number(row?.cost_percentage).toFixed(2) : "-"}</td>
                                                    <td className='text-end'>{row?.net_sales ? showPrice(row?.net_sales) : "-"}</td>
                                                    <td className='text-end'>{showPrice(row?.item_total_discount ?? 0)}</td>
                                                    <td className='text-end'>15</td>
                                                    <td className='text-end'>{row?.net_sales_without_tax ? showPrice(row?.net_sales_without_tax) : "-"}</td>
                                                    <td className='text-end'>{row?.item_total_cost ? showPrice(row?.item_total_cost) : "-"}</td>
                                                    <td className='text-end'>{row?.item_total_profit ? showPrice(row?.item_total_profit) : "-"}</td>
                                                    <td className='text-end'>{row?.item_total_profit_margin ? showPrice(row?.item_total_profit_margin) : "-"}</td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={24} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No record found</p>
                                                </td>
                                            </tr>
                                            }</>}
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "brand-item-cost-calculation", path: "/company/brand-report/item_cost/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="top-right"
                    hideProgressBar={false}
                    autoClose={true | 1000}
                    newestOnTop={true}
                    closeOnClick={false}
                    draggable={false}
                    rtl={false}
                />

            </div>
        </>
    );
}

export default BrandItemCostList
